<div class="cart-container">
  <a routerLink="/" class="back-link">
    <span class="material-icons">arrow_back</span> Back to Home
  </a>
  <h2 class="page-title">Shopping Cart</h2>
  <div class="cart-subtitle" *ngIf="cartItems$ | async as items">
    <p *ngIf="items.length > 0">
      {{ items.length }} {{ items.length === 1 ? "item" : "items" }}
    </p>
  </div>

  <div class="cart-layout" *ngIf="cartItems$ | async as items">
    <div class="empty-cart" *ngIf="items.length === 0">
      <p>Your cart is empty.</p>
      <button class="browse-btn" routerLink="/">Browse Vehicles</button>
    </div>

    <ng-container *ngIf="items.length > 0">
      <!-- LEFT: Items List -->
      <div class="items-list">
        <div
          class="cart-item"
          *ngFor="let item of items"
          [class.unavailable]="isItemUnavailable(item.id)"
        >
          <div class="item-image">
            <img
              [src]="
                item.equipmentData?.images?.[0] ||
                'assets/default-equipment.jpg'
              "
              alt="Vehicle Image"
            />
          </div>

          <div class="item-main-content">
            <div class="item-header">
              <div class="item-info">
                <h3>{{ item.equipmentData?.listingName || item.equipmentData?.name }}</h3>
                <p class="brand">
                  {{ item.equipmentData?.brand }}
                  <span *ngIf="item.equipmentData?.emirate">
                    • {{ item.equipmentData?.emirate }}</span
                  >
                </p>
              </div>
              <div class="item-price">
                AED {{ item.totalAmount | number: "1.2-2" }}
              </div>
            </div>

            <div class="unavailable-status" *ngIf="isItemUnavailable(item.id)">
              <span class="material-icons">warning</span>
              Not Available for These Dates
            </div>

            <div class="item-details-row">
              <div class="dates">
                <span
                  >From:
                  <strong>{{
                    item.startDate | date: "dd/MM/yyyy"
                  }}</strong></span
                >
                <span
                  >Till:
                  <strong>{{ item.endDate | date: "dd/MM/yyyy" }}</strong></span
                >
              </div>
              <div class="rate-info">
                Rate: AED {{ item.rate }} / {{ item.priceType }}
              </div>
            </div>

            <div class="action-buttons">
              <button class="edit-btn" (click)="editItem(item)">
                <span class="material-icons">edit_note</span> Edit
              </button>
              <button class="remove-btn" (click)="removeItem(item.id)">
                <span class="material-icons">delete_outline</span> Remove
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- RIGHT: Summary -->
      <div class="summary-card">
        <h3>Order Summary</h3>


        <div class="summary-items">
          <div class="summary-item-row" *ngFor="let item of items">
            <span class="item-name">{{ item.equipmentData?.listingName || item.equipmentData?.name }}</span>
            <span class="item-price"
              >AED {{ item.totalAmount | number: "1.0-0" }}</span
            >
          </div>
        </div>

        <div class="summary-total-section">
          <div class="summary-row total">
            <span>Total</span>
            <span class="total-amount"
              >AED {{ totalAmount | number: "1.2-2" }}</span
            >
          </div>
        </div>
        <div class="summary-disclaimer">
          <label class="terms-text">
            <input
              type="checkbox"
              (change)="onTermsCheckboxChange($event)"
              [checked]="termsAccepted"
            />
            <span
              >I agree to Aluguloo's
              <a (click)="openTermsDialog($event)" style="cursor: pointer;">Terms & Conditions</a></span
            >
          </label>
        </div>
        <button
          class="checkout-btn"
          [disabled]="hasUnavailableItems() || !termsAccepted"
          (click)="proceedToConfirm()"
        >
          Confirm Enquiry
        </button>
        <p class="error-text" *ngIf="hasUnavailableItems()">
          Please remove unavailable items to proceed.
        </p>

        <div class="summary-disclaimer">
          <div class="disclaimer-text">
            <span class="material-symbols-outlined">shield</span>
            <p>
              Payments are not processed through Aluguloo.<br />
              The total shown is calculated based on the listed rates by
              respective vendors.<br />
              All financial transactions are to be handled directly with the
              vendor as per agreed terms.
            </p>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
